export default () => ({
  schedule: {
    id: null
  },
  covenant: null,
  patient: {},
  professional: {},
  speciality: null,
  specialities: [],
  covenants: [],
  showModal: false,
  showModalProfileProfessional: false
})



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/components/event-details/resources/data.js